import {
  WEBSITE_CRM_DEMO_HTML_ARTIFACT_ID,
} from './websiteCrmDemo.js'
import { buildWebsiteCrmHtmlArtifactPayload } from './websiteCrmDemoContent.js'

/**
 * @param {import('@/features/documentPreview/documentPreviewTypes.js').DocumentPreviewSelection} selection
 */
export function isWebsiteCrmHtmlArtifact(selection) {
  const name = String(selection?.fileName ?? '').toLowerCase()
  return (
    selection?.artifactId === WEBSITE_CRM_DEMO_HTML_ARTIFACT_ID ||
    name.includes('procurement site') ||
    name.endsWith('.html')
  )
}

/**
 * @param {import('@/features/documentPreview/documentPreviewTypes.js').DocumentPreviewSelection} selection
 */
export function isWebsiteCrmDocArtifact(selection) {
  const name = String(selection?.fileName ?? '').toLowerCase()
  return name.includes('crm test report') || name.includes('nexusb2b — crm test report')
}

/**
 * @param {string | undefined} artifactId
 * @param {import('@/features/documentPreview/documentPreviewTypes.js').DocumentPreviewSelection} selection
 */
export function buildWebsiteCrmHtmlArtifact(artifactId, selection) {
  const id = artifactId || WEBSITE_CRM_DEMO_HTML_ARTIFACT_ID
  return {
    artifactId: id,
    kind: 'html',
    fileName: selection?.fileName ?? 'NexusB2B — Procurement Site.html',
    description: selection?.description ?? 'HTML App',
    payload: buildWebsiteCrmHtmlArtifactPayload(),
  }
}
